'use strict';
/* LP Collagène articulaire — Novoma
   Configurateur (saveur × durée × abonnement), galerie produit, ajout au panier Shopify, avis clients fixes. */
(() => {
const configEl = document.querySelector('#lp-col-config');
let CONFIG = {};
try { CONFIG = JSON.parse(configEl ? configEl.textContent : '{}'); } catch (e) { console.error('[LP] Config JSON invalide', e); }

/* ---------- Barre d'achat fixe : indépendante du reste, s'affiche sous le haut de page ---------- */
try {
  const sticky = document.querySelector('.lp-sticky'), hero = document.getElementById('hero-title')?.closest('section') || document.querySelector('section.hero');
  if (sticky) {
    /* Placée directement dans <body> pour échapper aux conteneurs animés ou masqués par d'autres scripts */
    document.body.appendChild(sticky);
    const update = () => {
      if (!sticky.isConnected) document.body.appendChild(sticky);
      const shop = document.getElementById('shopping');
      /* Apparaît dès que le bouton du hero est sorti de l'écran (ou passé sous l'en-tête fixe) */
      const heroCta = document.querySelector('.hero-cta') || hero;
      const headEl = document.querySelector('header');
      const headBottom = headEl && getComputedStyle(headEl.closest('.shopify-section') || headEl).position === 'sticky' ? Math.max(0, headEl.getBoundingClientRect().bottom) : 0;
      let show = heroCta ? heroCta.getBoundingClientRect().bottom <= headBottom : window.scrollY > 500;
      /* Masquée pendant que l'offre est à l'écran, réaffichée une fois l'offre passée */
      if (document.getElementById('cart-drawer-v2')?.classList.contains('active')) show = false;
      if (show && shop) { const r = shop.getBoundingClientRect(); if (r.top < window.innerHeight - 80 && r.bottom > 80) show = false; }
      sticky.hidden = !show;
      sticky.style.setProperty('display', show ? 'flex' : 'none', 'important');
      sticky.style.setProperty('visibility', 'visible', 'important');
      sticky.style.setProperty('opacity', '1', 'important');
    };
    document.addEventListener('scroll', update, {capture: true, passive: true});
    window.addEventListener('resize', update);
    setInterval(update, 500);
    update();
  }
} catch (e) { console.error('[LP] barre fixe', e); }

const form = document.querySelector('#offre');
if (form) try {
const money = new Intl.NumberFormat('fr-FR', {style: 'currency', currency: CONFIG.currency || 'EUR'});

/* Prix de secours (maquette) si le produit Shopify n'est pas encore relié */
const FALLBACK = {1: {single: 3990, subscription: 3591}, 3: {single: 10773, subscription: 9696}};

function entry(flavor, months) {
  const f = CONFIG.flavors && CONFIG.flavors[flavor];
  return f && f[String(months)] ? f[String(months)] : null;
}
function priceFor(flavor, months, subscription) {
  const e = entry(flavor, months);
  if (e) {
    const base = subscription && e.planPrice != null ? e.planPrice : e.price;
    /* Cure 3 mois = 3 × la variante : remise quantité (comme la fiche produit).
       En abonnement, elle ne s'ajoute à la remise Recharge que si « Cumuler… » est coché. */
    const vd = e.qty > 1 && (!subscription || CONFIG.volumeOnSub) ? Number(CONFIG.volumeDiscount3 || 0) : 0;
    return Math.round(base * (1 - vd / 100));
  }
  return FALLBACK[months][subscription ? 'subscription' : 'single'];
}
/* Prix de référence d'un sachet sans abonnement (base des remises affichées) */
function referenceCents(flavor) {
  const e = entry(flavor, 1);
  return e ? Math.round(e.price / e.qty) : FALLBACK[1].single;
}

function selection() {
  const d = new FormData(form), months = Number(d.get('duration')), subscription = d.has('subscribe'), flavor = d.get('flavor');
  return {flavor, months, subscription, cents: priceFor(flavor, months, subscription)};
}

function render() {
  const s = selection(), period = s.months === 1 ? 'chaque mois' : `tous les ${s.months} mois`;
  const ref = referenceCents(s.flavor);
  const discountFor = m => Math.max(0, Math.round((1 - priceFor(s.flavor, m, s.subscription) / (ref * m)) * 100));
  const discount = discountFor(s.months);
  document.querySelector('#subscription-discount').textContent = `Économisez ${discount} % sur votre cure`;
  document.querySelector('#subscription-benefits').hidden = !s.subscription;
  
  for (const months of [3, 1]) {
    const cents = priceFor(s.flavor, months, s.subscription), saved = ref * months - cents;
    const tag = document.querySelector(`[data-duration-saving="${months}"]`); tag.textContent = '−' + discountFor(months) + ' %'; tag.hidden = saved <= 0;
    const saving = document.querySelector(`[data-total-saving="${months}"]`); saving.textContent = money.format(saved / 100) + ' économisés'; saving.hidden = saved <= 0;
    const refEl = document.querySelector(`[data-duration-reference="${months}"]`); refEl.textContent = money.format(ref / 100); refEl.hidden = saved <= 0;
    document.querySelector(`[data-duration-price="${months}"]`).textContent = money.format(cents / 100 / months);
    document.querySelector(`[data-duration-unit="${months}"]`).textContent = money.format(cents / 100 / (28 * months)) + ' / jour';
  }
  const cur = entry(s.flavor, s.months), planName = cur && cur.planName ? cur.planName.toLowerCase() : period;
  const sachets = `${s.months} sachet${s.months > 1 ? 's' : ''}`;
  const free = c => c >= (CONFIG.freeShipping || 6500);
  document.querySelector('#renewal').textContent = s.subscription ? `${sachets} par livraison · ${planName}` : 'Achat unique · Aucun renouvellement';
  document.querySelector('#billing').textContent = money.format(s.cents / 100) + (s.subscription ? ' par livraison, ' + planName : ' en une seule fois') + (free(s.cents) ? '. Livraison offerte.' : '. Hors frais de livraison.');
  document.querySelector('#shipping').textContent = free(s.cents) ? 'Livraison offerte' : 'Frais de livraison au paiement';
  const ds = document.querySelector('[data-duration-shipping="3"]'); if (ds) ds.hidden = !free(priceFor(s.flavor, 3, s.subscription));
  /* Remise maximale (cure 3 mois en abonnement) et FAQ : toujours alignées sur les prix Shopify */
  const pct = (c, m) => '−' + Math.max(0, Math.round((1 - c / (ref * m)) * 100)) + ' %';
  const sub3 = priceFor(s.flavor, 3, true), single3 = priceFor(s.flavor, 3, false), sub1 = priceFor(s.flavor, 1, true);
  document.querySelectorAll('[data-lp-max]').forEach(el => el.textContent = pct(sub3, 3));
  const faq = {ref: money.format(ref / 100), ref3: money.format(ref * 3 / 100), single3: money.format(single3 / 100), single3pct: pct(single3, 3), sub3: money.format(sub3 / 100), sub3pct: pct(sub3, 3), sub1: money.format(sub1 / 100), sub1pct: pct(sub1, 1), free: money.format((CONFIG.freeShipping || 6500) / 100)};
  document.querySelectorAll('[data-faq]').forEach(el => { if (faq[el.dataset.faq]) el.textContent = faq[el.dataset.faq]; });
  document.querySelector('#sticky-detail').textContent = `${s.flavor} · ${s.months} mois · ` + (s.subscription ? 'Abonnement' : 'Achat unique');
  document.querySelector('#sticky-price').textContent = money.format(s.cents / 100 / s.months) + ' / sachet';
  const sd = document.querySelector('#sticky-discount'); sd.textContent = '−' + discount + ' %'; sd.hidden = !discount;
  const e = entry(s.flavor, s.months);
  const btn = form.querySelector('.purchase-cta');
  const soldOut = e && e.available === false;
  btn.disabled = !!soldOut;
  btn.querySelector('span').textContent = soldOut ? 'ÉPUISÉ' : (btn.dataset.label || 'DÉMARRER');
}

/* ---------- Ajout au panier ---------- */
const errorEl = document.querySelector('#lp-cart-error');
function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.hidden = !msg; } }

form.addEventListener('change', e => {
  showError('');
  render();
  if (e.target.name === 'flavor') {
    const fl = selection().flavor, i = slides.findIndex(b => b.dataset.flavor === fl);
    if (i >= 0) showSlide(i); else if (fl === 'Citron') showSlide(0);
  }
});

form.addEventListener('submit', async e => {
  e.preventDefault();
  showError('');
  const s = selection(), item = entry(s.flavor, s.months);
  if (!CONFIG.productConfigured || !item) {
    showError('Produit non configuré : sélectionnez le produit et ses variantes dans les réglages de la section.');
    return;
  }
  if (s.subscription && !item.plan) {
    showError('Aucun plan d’abonnement trouvé pour cette option. Vérifiez l’app d’abonnement ou décochez l’abonnement.');
    return;
  }
  const line = {id: item.id, quantity: item.qty};
  if (s.subscription) line.selling_plan = item.plan;
  line.properties = {_source: 'LP collagène articulaire'};
  const btn = form.querySelector('.purchase-cta');
  btn.disabled = true; btn.setAttribute('aria-busy', 'true');
  try {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [line]})
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.description || data.message || 'Ajout au panier impossible.');
    }
    if (CONFIG.redirect === 'drawer' && document.getElementById('cart-drawer-v2')) {
      /* Le panier du thème (cart-drawer.js) détecte l'ajout, se met à jour et s'ouvre tout seul */
      btn.disabled = false; btn.removeAttribute('aria-busy');
    } else if (CONFIG.redirect === 'drawer') {
      window.location.href = root + 'cart';
    } else {
      window.location.href = root + (CONFIG.redirect === 'cart' ? 'cart' : 'checkout');
    }
  } catch (err) {
    showError(err.message || 'Une erreur est survenue. Merci de réessayer.');
    btn.disabled = false; btn.removeAttribute('aria-busy');
  }
});

/* ---------- Galerie produit ---------- */
const slides = [...document.querySelectorAll('.gallery-thumb')]; let current = 0, requestId = 0;
const gallery = document.querySelector('.shop-gallery'), stage = document.querySelector('.gallery-stage'), productImage = document.querySelector('#shop-product');
const galleryPreloads = slides.map(button => { const img = new Image(); img.src = button.dataset.image; return img; });
async function showSlide(index) {
  if (!slides.length) return;
  current = (index + slides.length) % slides.length;
  const target = current, request = ++requestId, button = slides[target], cached = galleryPreloads[target];
  gallery.setAttribute('aria-busy', 'true');
  try { if (!cached.complete || !cached.naturalWidth) await cached.decode(); } catch { if (request === requestId) gallery.setAttribute('aria-busy', 'false'); return; }
  if (request !== requestId) return;
  productImage.src = button.dataset.image; productImage.alt = button.dataset.alt;
  slides.forEach((b, i) => { b.classList.toggle('active', i === target); b.setAttribute('aria-pressed', String(i === target)); });
  document.querySelector('#gallery-count').textContent = (target + 1) + ' / ' + slides.length;
  gallery.classList.toggle('is-not-first', target !== 0);
  gallery.setAttribute('aria-busy', 'false');
}
if (slides.length) {
  slides.forEach((b, i) => b.addEventListener('click', () => showSlide(i)));
  document.querySelector('#gallery-prev').addEventListener('click', () => showSlide(current - 1));
  document.querySelector('#gallery-next').addEventListener('click', () => showSlide(current + 1));
  gallery.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showSlide(current + (e.key === 'ArrowRight' ? 1 : -1)); } });
  let touchStart = null;
  stage.addEventListener('touchstart', e => { touchStart = e.touches.length === 1 ? {x: e.touches[0].clientX, y: e.touches[0].clientY} : null; }, {passive: true});
  stage.addEventListener('touchend', e => { if (!touchStart) return; const dx = e.changedTouches[0].clientX - touchStart.x, dy = e.changedTouches[0].clientY - touchStart.y; touchStart = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) showSlide(current + (dx < 0 ? 1 : -1)); }, {passive: true});
  stage.addEventListener('touchcancel', () => touchStart = null, {passive: true});
} else {
  const controls = document.querySelector('.gallery-controls'); if (controls) controls.hidden = true;
}
if (productImage) productImage.draggable = false;

render(); if (slides.length) showSlide(0);
} catch (e) { console.error('[LP] bloc d’achat', e); } /* fin bloc d'achat */

/* ---------- Pharmacies ---------- */
const pharmacyTrack = document.querySelector('.pdp-pharmacy-track'), pharmacyDots = [...document.querySelectorAll('[data-pharmacy]')];
if (pharmacyTrack) {
  pharmacyDots.forEach(button => button.addEventListener('click', () => pharmacyTrack.scrollTo({left: Number(button.dataset.pharmacy) / (pharmacyDots.length - 1) * (pharmacyTrack.scrollWidth - pharmacyTrack.clientWidth), behavior: 'smooth'})));
  pharmacyTrack.addEventListener('scroll', () => { const max = pharmacyTrack.scrollWidth - pharmacyTrack.clientWidth, index = max ? Math.round(pharmacyTrack.scrollLeft / max * (pharmacyDots.length - 1)) : 0; pharmacyDots.forEach((b, i) => b.setAttribute('aria-pressed', String(i === index))); }, {passive: true});
}

/* ---------- Avis clients fixes (carrousel) ---------- */
const reviewRail = document.querySelector('#avis .lp-review-rail');
if (reviewRail) {
  const controls = document.querySelector('#avis .review-carousel-controls');
  const dots = controls ? [...controls.querySelectorAll('[data-review-slide]')] : [];
  const cards = [...reviewRail.querySelectorAll('.lp-review')];
  let currentReview = 0, inView = false, lastInteraction = 0;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const setDots = () => dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === currentReview)));
  function goToReview(index) {
    if (!cards.length) return;
    currentReview = (index + cards.length) % cards.length;
    reviewRail.scrollTo({left: cards[currentReview].offsetLeft - reviewRail.offsetLeft, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
    setDots();
  }
  if (controls) controls.addEventListener('click', event => {
    const button = event.target.closest('button'); if (!button) return;
    lastInteraction = Date.now();
    if (button.hasAttribute('data-review-slide')) goToReview(Number(button.dataset.reviewSlide));
    else if (button.hasAttribute('data-review-step')) goToReview(currentReview + Number(button.dataset.reviewStep));
  });
  reviewRail.addEventListener('pointerdown', () => { lastInteraction = Date.now(); });
  reviewRail.addEventListener('scroll', () => {
    const w = reviewRail.clientWidth || 1;
    currentReview = Math.max(0, Math.min(cards.length - 1, Math.round(reviewRail.scrollLeft / w)));
    setDots();
  }, {passive: true});
  new IntersectionObserver(([en]) => { inView = en.isIntersecting; }, {threshold: .3}).observe(reviewRail);
  setInterval(() => {
    if (inView && !reducedMotion.matches && !document.hidden && !reviewRail.matches(':hover') && !document.querySelector('#avis').contains(document.activeElement) && Date.now() - lastInteraction > 12000) goToReview(currentReview + 1);
  }, 8000);
}
})();

/* ---------- Diagnostic : ajouter ?lpdebug=1 à l'adresse pour lister ce qui dépasse à droite ---------- */
if (/[?&]lpdebug=1/.test(location.search)) {
  const run = () => {
    const W = document.documentElement.clientWidth;
    const found = [];
    document.querySelectorAll('body *').forEach(el => {
      const r = el.getBoundingClientRect();
      if (el.id === 'lp-debug' || !r.width || r.right <= W + 2) return;
      for (let a = el.parentElement; a && a !== document.body; a = a.parentElement) {
        if (getComputedStyle(a).overflowX !== 'visible') return; /* déjà coupé par un parent */
      }
      const parentWide = el.parentElement && el.parentElement !== document.body && el.parentElement.getBoundingClientRect().right > W + 2;
      if (!parentWide) found.push(el);
    });
    found.forEach(el => { el.style.outline = '3px solid red'; });
    let box = document.getElementById('lp-debug');
    if (!box) { box = document.createElement('pre'); box.id = 'lp-debug'; box.style.cssText = 'position:fixed;top:0;left:0;right:0;max-height:45vh;overflow:auto;z-index:2147483647;background:#111;color:#0f0;font:11px/1.4 monospace;padding:8px;margin:0;white-space:pre-wrap'; document.body.appendChild(box); }
    box.textContent = `écran ${W}px · page ${document.documentElement.scrollWidth}px · body ${document.body.scrollWidth}px\n` +
      (found.length ? found.slice(0, 15).map(el => `${el.tagName.toLowerCase()}${el.id ? '#' + el.id : ''}${el.className && typeof el.className === 'string' ? '.' + el.className.trim().split(/\s+/).slice(0, 3).join('.') : ''} → ${Math.round(el.getBoundingClientRect().right)}px · dans ${el.closest('main') ? 'la page' : 'body (app/script)'}`).join('\n') : 'Rien ne dépasse.');
  };
  setTimeout(run, 3000); setInterval(run, 4000);
}

/* ---------- Drapeau 🇫🇷 après chaque « Fabriqué en France » (sans doublon si déjà présent) ---------- */
try {
  const addFlag = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: n => /fabriqu[ée]e? en france/i.test(n.nodeValue) && !n.parentElement.closest('script,style,textarea') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
    });
    const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(n => { n.nodeValue = n.nodeValue.replace(/(fabriqu[ée]e? en france)(?!\s*🇫🇷)/gi, '$1 🇫🇷'); });
  };
  addFlag(document.querySelector('main') || document.body);
  const sticky = document.querySelector('.lp-sticky'); if (sticky) addFlag(sticky);
} catch (e) { console.error('[LP] drapeau', e); }

/* ---------- En-tête fixe : ombre légère dès qu'on défile ---------- */
try {
  const head = document.querySelector('header')?.closest('.shopify-section');
  if (head) { const f = () => head.classList.toggle('is-scrolled', window.scrollY > 4); window.addEventListener('scroll', f, {passive: true}); f(); }
} catch (e) {}





/* ---------- Icône panier du site : on déplace celle du thème dans l'en-tête de la LP ---------- */
try {
  const moveCartIcon = () => {
    const icon = document.getElementById('cart-icon-bubble'), lpHeader = document.querySelector('main header');
    if (!icon || !lpHeader || lpHeader.contains(icon)) return;
    /* Bouton puis icône panier, regroupés à droite (comme la LP NV) : logo | menu | bouton + panier */
    const cta = lpHeader.querySelector('.nav-cta');
    const group = document.createElement('div'); group.className = 'lp-head-actions';
    if (cta) { lpHeader.insertBefore(group, cta); group.appendChild(cta); group.appendChild(icon); }
    else { lpHeader.appendChild(group); group.appendChild(icon); }
    icon.classList.add('lp-cart-icon');
  };
  moveCartIcon();
  document.addEventListener('DOMContentLoaded', moveCartIcon);
} catch (e) { console.error('[LP] icône panier', e); }
